module.exports = __webpack_public_path__ + "2a8adc92f729dd1290d5a2b8b7224fcc.svg";